/* app/js/src/components/graphics/edit/choose-day-and-time/choose-day-and-time.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
.container .field {
  margin-bottom: 10px;
}
.container .time-picker,
.container .apply-btn {
  width: 10vw;
}
.container .apply-btn {
  color: white;
  background-color: #232F3A;
}
.container .header {
  text-align: center;
}
/*# sourceMappingURL=choose-day-and-time.component.css.map */
